import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Navigate, useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;
const KEY = "masaya_portal_token";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem(KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

const Ctx = createContext(null);
export const usePortalAuth = () => useContext(Ctx);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, object=user
  const load = useCallback(async () => {
    if (!localStorage.getItem(KEY)) { setUser(false); return; }
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { localStorage.removeItem(KEY); setUser(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(KEY, data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => { localStorage.removeItem(KEY); setUser(false); };
  const refresh = load;
  const changePassword = async (current_password, new_password) => {
    await api.post("/auth/change-password", { current_password, new_password });
    await load();
  };
  return <Ctx.Provider value={{ user, login, logout, refresh, changePassword }}>{children}</Ctx.Provider>;
}

// Prevent search indexing of portal pages
export function useNoIndex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex, nofollow, noarchive";
    document.head.appendChild(m);
    return () => document.head.removeChild(m);
  }, []);
}

export function RoleRoute({ allow, loginPath, children }) {
  const { user } = usePortalAuth();
  const location = useLocation();
  useNoIndex();
  if (user === null) return <div className="pt-40 text-center text-[#78716C]">Loading…</div>;
  if (!user) return <Navigate to={loginPath} state={{ from: location }} replace />;
  if (!allow.includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

export function extractErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong.";
}
